module.exports = __webpack_public_path__ + "static/fonts/DS-DIGIB.1467e2d3.TTF";